import React from 'react';

import Typography from '@components/typography';
import ImageGalleryButton from './imagebutton';

import VehicleImage from './vehicleimage';

import '@styles/configure/vehiclebanner.scss';
import { useSitcoreComponentData } from '@hooks/usesitecorecomponentdata';

import { Vehicle } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicle';

interface VehicleBannerProps {
  vehicle: Vehicle;
  onImageGallery: () => void;
}

const VehicleBanner: React.FC<VehicleBannerProps> = ({
  vehicle,
  onImageGallery,
}) => {
  const { config } = useSitcoreComponentData();

  return (
    <section className="configure-header wide-component-container">
      <div
        className="vehicle-banner"
        data-testid="vehicle-banner"
        data-cy="vehicle-banner"
      >
        <div className="vehicle-banner__container">
          <div className="text-layout" data-testid="text-layout">
            <div className="text-layout__content">
              <Typography variant="h1" size="3x" weight="bold">
                {vehicle.make} {vehicle.model}
              </Typography>
              <Typography variant="h2" size={'2x'} weight="normal">
                {vehicle.type}
              </Typography>
            </div>
          </div>
          <div className="image-layout" data-testid="image-layout">
            <div className="image-layout__content">
              <VehicleImage
                fallbackImg={config?.fallbackVehicleImageSrc}
                src={vehicle.image}
                loading={'eager'}
                modelCode={vehicle.modelCode}
                doors={vehicle.doors}
                train={vehicle.train}
                trim={vehicle.trim}
                year={vehicle.year}
                vehicle={vehicle}
              />
            </div>
          </div>
          <div className="button-layout">
            <div className="button-layout__content" data-testid="button-layout">
              <ImageGalleryButton onImageGallery={onImageGallery} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default VehicleBanner;
